import React, { useEffect, Component } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
// Components
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { AboutPage } from './pages/AboutPage';
import { ProcessPage } from './pages/ProcessPage';
import { ContactPage } from './pages/ContactPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
// Page transition wrapper
function PageWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="w-full" data-id="element-0">
      {children}
    </motion.div>;
}
// Animated Routes component to handle AnimatePresence properly
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-1">
      <Routes location={location} key={location.pathname} data-id="element-2">
        <Route path="/" element={<PageWrapper data-id="element-4">
              <HomePage data-id="element-5" />
            </PageWrapper>} data-id="element-3" />
        <Route path="/services" element={<PageWrapper data-id="element-7">
              <ServicesPage data-id="element-8" />
            </PageWrapper>} data-id="element-6" />
        <Route path="/portfolio" element={<PageWrapper data-id="element-10">
              <PortfolioPage data-id="element-11" />
            </PageWrapper>} data-id="element-9" />
        <Route path="/about" element={<PageWrapper data-id="element-13">
              <AboutPage data-id="element-14" />
            </PageWrapper>} data-id="element-12" />
        <Route path="/process" element={<PageWrapper data-id="element-16">
              <ProcessPage data-id="element-17" />
            </PageWrapper>} data-id="element-15" />
        <Route path="/contact" element={<PageWrapper data-id="element-19">
              <ContactPage data-id="element-20" />
            </PageWrapper>} data-id="element-18" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <HashRouter data-id="element-21">
      <ScrollToTop data-id="element-22" />
      <div className="flex flex-col min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-23">
        <Navbar data-id="element-24" />
        <main className="flex-grow flex flex-col w-full" data-id="element-25">
          <AnimatedRoutes data-id="element-26" />
        </main>
        <Footer data-id="element-27" />
      </div>
    </HashRouter>;
}